console.log("init Proteus Treatments - 0.28");

// support for cart data
fetch('/cart.js').then((res) => res.json()).then((cart) => {
  window.cart_data = cart;
});

document.addEventListener("cart:change", (event) => {
  window.cart_data = event.detail["cart"];
});

observeSelector('[class*="checkmate-"]', checkmate_widget => {
//  checkmate_widget.remove();
})

window.dataLayer = window.dataLayer || [];
const ga4_custom_metric = (name) => {
  console.log("ga4_custom_metric()", name);
  dataLayer.push({
    'event': 'proteus_custom_event',
    'proteus_event_name': name,
    'proteus_event_category': "CRO",
    'page_location': window.location.href
  });
};

observeSelector("buy-buttons button", atc_btn => {
  atc_btn.addEventListener("click", () => {
    setTimeout(() => {
      if(document.querySelectorAll('input[name="selling_plan"]').length > 0 && document.querySelector('input[name="selling_plan"]').value != ""){
        ga4_custom_metric("ATC subscription"); 
      } else {
        ga4_custom_metric("ATC one-time"); 
      }
      
    }, 500)
  })
})

// tag clarity items as standard so that they can be reviewed post-purchase

observeSelector('line-item[data-var-id="43516623552754"]', clarity_line_item => {
  let data_props = clarity_line_item.getAttribute("data-props") || "";  // Handle potential null

  console.log("observing clarity", data_props);
  
  if (data_props.indexOf("standard") > -1 || data_props.indexOf("_FREECLARITY") > -1) {
    console.log("CLARITY -- already set");
  } else {
    let data_key = clarity_line_item.getAttribute("data-key");
    let data_qty = clarity_line_item.getAttribute("data-qty");

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: data_key, 
        quantity: data_qty, 
        properties: {
          '_purchase-type': 'standard'  
        }
      })
    }).then(response => response.json()).then(data => {
      console.log('Cart updated:', data);
      const event = new Event('cart:refresh');
      document.dispatchEvent(event);
    }).catch(error => {
      console.error('Error updating cart:', error);
    });
  }
});


/*
[PT - 08] GWP on Popup
v2: free Clarity
*/

if(getParam("gwp") == "sunstick" && !window.sessionStorage.getItem("gwp-added")){
  window.sessionStorage.setItem("gwp-added", "sunstick");
  window.location = `/cart/add?items[][id]=32293511921803&items[][quantity]=1&items[][properties][_FREESUNSTICK]=true&return_to=${window.location.pathname}`;
}

if(getParam("gwp") == "clarity" && !window.sessionStorage.getItem("gwp-added")){
  window.sessionStorage.setItem("gwp-added", "clarity");
  window.location = `/cart/add?items[][id]=43516623552754&items[][quantity]=1&items[][properties][_FREECLARITY]=true&return_to=${window.location.pathname}`;
}

if(getParam("gwp") == "immunity" && !window.sessionStorage.getItem("gwp-added")){
  window.sessionStorage.setItem("gwp-added", "immunity");
  window.location = `/cart/add?items[][id]=45156013113586&items[][quantity]=1&items[][properties][_FREEIMMUNITY]=true&return_to=${window.location.pathname}`;
}

/*

[PT-39] Shipping Threshold $45 v $55 -- 0.01

*/

waitForElement('body').then(doc => {

  window._shipScout = window._shipScout || [];
  _shipScout.push(function (response) {
    
    console.log(response)
    window.ss_variant = response.variant

    let threshold_cents = 0;
    if(!!response.thresholdCents){
      threshold_cents = response.thresholdCents;
    }
    
    dataLayer.push({
      'event': 'proteus_experiment_pageview',
      'proteus_exp_id': "PT-39",
      'proteus_var_id': response.variant,
      'proteus_exp_name': `Free Shipping $${(threshold_cents / 100).toFixed(0)}`,
      'proteus_exp_version': "0.01",
    });

    console.log(`[PT-39] Free Shipping $${(threshold_cents / 100).toFixed(0)}`);
    init_ss_progressive_bar(threshold_cents);

  })

  const init_ss_progressive_bar = (fs_threshold) => {

    const incentives_goals = [
      {
        threshold: fs_threshold,
        message: "FREE SHIPPING",
        label: "free shipping",
        var_id: "none"
      }
    ];
  
    const checkmark_svg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="800px" width="800px" version="1.1" id="Capa_1" viewBox="0 0 17.837 17.837" xml:space="preserve">
    <g>
      <path d="M16.145,2.571c-0.272-0.273-0.718-0.273-0.99,0L6.92,10.804l-4.241-4.27   c-0.272-0.274-0.715-0.274-0.989,0L0.204,8.019c-0.272,0.271-0.272,0.717,0,0.99l6.217,6.258c0.272,0.271,0.715,0.271,0.99,0   L17.63,5.047c0.276-0.273,0.276-0.72,0-0.994L16.145,2.571z"/>
    </g>
    </svg>`;
  
    // inject treatment styles
    doc.insertAdjacentHTML("afterbegin", `
      <style>
        
        .cart-drawer__top{
          position: absolute;
          top: 1rem;
          width: 560px;
          max-width: calc(100% - 45px);
        }
  
        .js-hidden,
        #slidecarthq .slidecarthq > .rewards{
          display: none; 
          opacity: 0;
          position: absolute;
          left: -9999px;
        }
  
        /* ------
        adjust cart order so free shipping module is first
        ------ */
  
        #slidecarthq .slidecarthq > header{
          order: 1;
        }
  
        #slidecarthq .slidecarthq > div{
          order: 5;
        }
  
        #slidecarthq .slidecarthq > .rewards{
          order: 2;
        }
  
        #slidecarthq .slidecarthq > footer{
          order: 10;
        }
  
        /* --- START INCENTIVES MODULE --- */
  
          #slidecarthq .slidecarthq > .js-incentives{
            order: 2;
          }
  
          #slidecarthq .slidecarthq.cartEmpty > .js-incentives{
            display: none;
          }
  
          .js-incentives{
            background: #1ba9e1;
            color: #fff;
            padding: 18px 30px;
            margin-top: 3rem;
          }
  
          .js-incentives-mesage{
            font-size: 15px;
            text-align: center;
            margin-bottom: 1rem;
          }
  
          .js-incentives-mesage strong{
            font-weight: 600;
          }
  
          .js-incentives--bar{
            background: #0085A3;
            border-radius: 25px;
            height: 6px;
            position: relative;
            margin-bottom: 2rem;
          }
  
          .js-incentives--bar--filled{
            transition: .5s ease all;
            width: 10%;
            background: #fff;
            border-radius: 25px;
            height: 6px;
            position: absolute;
            left: 0;
            top: 0;
          }
  
          .js-incentives--goals{
  
          }
  
          .js-incentives--threshold{
            position: absolute;
            top: 0;
          }
  
          .js-incentives--threshold--dot{
            width: 18px;
            height: 18px;
            border-radius: 100%;
            background: #0085A3;
            position: absolute;
            top: -6px;
            left: -18px;
          }
  
          .js-incentives--threshold.js-threshold-met .js-incentives--threshold--dot{
            background: #fff;
          }
  
          .js-incentives--threshold--dot--icon{
            transition: .5s ease opacity;
            opacity: 0;
            padding: 3px;
            position: relative;
          }
  
          .js-incentives--threshold.js-threshold-met .js-incentives--threshold--dot--icon{
            opacity: 1;
          }
  
          .js-incentives--threshold--dot--icon svg{
            width: 100%; 
            height: auto;
            fill: #1ba9e1 !important;
            position: absolute;
            top: 0; 
            left: 0;
            transform: scale(.65);
          }
  
          .js-incentives--threshold--label{
            transition: .5s ease opacity;
            position: absolute;
            font-size: 11px;
            top: 16px;
            right: -30px;
            width: 78px;
            text-align: center;
            opacity: 0;
          }
  
          @media(max-width: 650px){
            .js-incentives--threshold--label{
              font-size: 9px !important;
            }
            .js-incentives{ margin-top:4rem;}
          }
  
          .js-incentives--threshold.js-reveal .js-incentives--threshold--label,
          .js-incentives--threshold.js-tease .js-incentives--threshold--label{
            opacity: 1;
          }
  
          .js-claim-incentives{
            margin-bottom: 1rem;
          }
  
          .js-claim-incentives,
          .js-claim-incentives--resilient,
          .js-claim-incentives--shirt,
          .js-claim-incentives--hat,
          .js-claim-incentives--yeti{
            display: none;
          }
  
          [data-resilient-threshold-met="true"][data-resilient-in-cart="false"] .js-claim-incentives,
          [data-shirt-threshold-met="true"][data-shirt-in-cart="false"] .js-claim-incentives,
          [data-hat-threshold-met="true"][data-hat-in-cart="false"] .js-claim-incentives,
          [data-yeti-threshold-met="true"][data-yeti-in-cart="false"] .js-claim-incentives{
            display: block;
            text-align: center;
            padding: 1rem;
            background: #000;
            color: #fff;
          }
  
          [data-resilient-threshold-met="true"][data-resilient-in-cart="false"] .js-claim-incentives--resilient,
          [data-shirt-threshold-met="true"][data-shirt-in-cart="false"] .js-claim-incentives--shirt,
          [data-hat-threshold-met="true"][data-hat-in-cart="false"] .js-claim-incentives--hat,
          [data-yeti-threshold-met="true"][data-yeti-in-cart="false"] .js-claim-incentives--yeti{
            display: block;
          }
  
      </style>
    `);
  
    observeSelector('cart-drawer', cart_drawer => {
  
      // auto open cart
      if(getParam("cart") == "open"){
        document.querySelector('cart-drawer').setAttribute("open", true)
        document.querySelector('cart-drawer').removeAttribute("inert")
        document.querySelector('cart-drawer').setAttribute("style", "opacity: 1; visibility: visible; right: 0px; top: 0px;");
        document.querySelector('cart-drawer').classList.value = "cart-drawer drawer drawer--lg show-close-cursor";
      }
  
      let thresholds_html = "";
      // set max to largest threshold's setting (which is expected to be the last item of the array)
      let incentives_max = incentives_goals[incentives_goals.length -1].threshold;
  
      for(let i = 0; i < incentives_goals.length; i++){
        // let range_position = (incentives_goals[i].threshold / incentives_max) * 100;
        let range_position = (i + 1) / incentives_goals.length * 100;
        thresholds_html = thresholds_html + `
          <div class="js-incentives--threshold" data-threshold="${incentives_goals[i].threshold}" data-var-id="${incentives_goals[i].var_id}" style="left: ${range_position}%;" data-range="${range_position}" data-label="${incentives_goals[i].message}">
            <div class="js-incentives--threshold--dot">
              <div class="js-incentives--threshold--dot--icon">${checkmark_svg}</div>
            </div>
            <div class="js-incentives--threshold--label">${incentives_goals[i].label}</div>
          </div>
        `;
      }
  
      let earned_discount_to_apply = "NONE";
      let earned_resilient_has_resilient = false;
      let earned_hat_has_hat = false;
      let earned_shirt_has_shirt = false;
      let earned_yeti_has_yeti = false;
  
      const update_incentives_module = (current_cart_subtotal, applied_discount_total) => {
  
        if(document.querySelectorAll('.js-incentives').length == 0){
          cart_drawer.insertAdjacentHTML("afterbegin", `
            <div class="js-incentives">
              <div class="js-incentives-mesage">Status...</div>
              <div class="js-incentives--bar">
                <div class="js-incentives--bar--filled"></div>
                <div class="js-incentives--goals">
                  ${thresholds_html}
                </div>
              </div>
            </div>
          `);
        }
        
  
        let current_cart_full_total = current_cart_subtotal - applied_discount_total
        // console.log("current_cart_subtotal -- applied_discount_total -- current_cart_full_total", current_cart_subtotal, applied_discount_total, current_cart_full_total)
  
        // review cart items to observe already-added incentives
        document.documentElement.setAttribute("data-cart-reviewed", "false");
        document.documentElement.setAttribute("data-resilient-in-cart", false);
        document.documentElement.setAttribute("data-hat-in-cart", false);
        document.documentElement.setAttribute("data-shirt-in-cart", false);
        document.documentElement.setAttribute("data-yeti-in-cart", false);
        let cart_items = document.querySelectorAll('.cart-drawer__line-items line-item'); 
        for(let i = 0; i < cart_items.length; i++){
          if(cart_items[i].innerText.indexOf("Resilient") > -1){
            document.documentElement.setAttribute("data-resilient-in-cart", true);
          } else if(cart_items[i].innerText.indexOf("Hat") > -1){
            document.documentElement.setAttribute("data-hat-in-cart", true);
          } else if(cart_items[i].innerText.indexOf("Yeti") > -1){
            document.documentElement.setAttribute("data-yeti-in-cart", true);
          } else if((cart_items[i].innerText.indexOf("Protekt") > -1 &&
          cart_items[i].innerText.indexOf(" T") > -1) || cart_items[i].innerText.indexOf("Shirt") > -1){
            document.documentElement.setAttribute("data-shirt-in-cart", true);
          }
          if(i == cart_items.length -1){
            document.documentElement.setAttribute("data-cart-reviewed", "true");
          }
        }
  
        waitUntil(() => {
          return document.documentElement.getAttribute("data-cart-reviewed") == "true";
        }).then(() => {
  
          setTimeout(() => {
  
            earned_resilient_has_resilient = document.documentElement.getAttribute("data-resilient-threshold-met") == "true" &&
            document.documentElement.getAttribute("data-resilient-in-cart") == "true" ? true : false;
  
            earned_shirt_has_shirt = document.documentElement.getAttribute("data-shirt-threshold-met") == "true" &&
            document.documentElement.getAttribute("data-shirt-in-cart") == "true" ? true : false;
            
            earned_hat_has_hat = document.documentElement.getAttribute("data-hat-threshold-met") == "true" && 
            document.documentElement.getAttribute("data-hat-in-cart") == "true" ? true : false ;
      
            earned_yeti_has_yeti = document.documentElement.getAttribute("data-yeti-threshold-met") == "true" &&
            document.documentElement.getAttribute("data-yeti-in-cart") == "true" ? true : false;
  
            // console.log("earned_discount_to_apply", earned_discount_to_apply, earned_shirt_has_shirt, earned_hat_has_hat, earned_yeti_has_yeti);
  
      
            if(earned_hat_has_hat && earned_shirt_has_shirt && earned_yeti_has_yeti && current_cart_full_total >= 33100){
              earned_discount_to_apply = "RESILIENT+HAT+SHIRT+YETI";
            } else if(!earned_hat_has_hat && earned_shirt_has_shirt && earned_yeti_has_yeti && current_cart_full_total >= 29600){
              earned_discount_to_apply = "RESILIENT+SHIRT+YETI";
            } else if(earned_hat_has_hat && !earned_shirt_has_shirt && earned_yeti_has_yeti && current_cart_full_total >= 30100){
              earned_discount_to_apply = "RESILIENT+HAT+YETI";
            } else if(earned_hat_has_hat && earned_shirt_has_shirt && !earned_yeti_has_yeti && current_cart_full_total >= 24100){
              earned_discount_to_apply = "RESILIENT+HAT+SHIRT";
            } else if(!earned_hat_has_hat && !earned_shirt_has_shirt && earned_yeti_has_yeti && current_cart_full_total >= 26600){
              earned_discount_to_apply = "RESILIENT+YETI";
            } else if(!earned_hat_has_hat && earned_shirt_has_shirt && !earned_yeti_has_yeti && current_cart_full_total >= 16100){
              earned_discount_to_apply = "RESILIENT+SHIRT";
            } else if(earned_hat_has_hat && !earned_shirt_has_shirt && !earned_yeti_has_yeti && current_cart_full_total >= 20600){
              earned_discount_to_apply = "RESILIENT+HAT";
            } else {
              if(current_cart_subtotal > 6000 && current_cart_full_total >= 9000){
                earned_discount_to_apply = "FREE_RESILIENT";
                // console.log("xxx", earned_hat_has_hat, earned_shirt_has_shirt, earned_yeti_has_yeti, current_cart_full_total)
              } else {
                earned_discount_to_apply = "NONE"; 
              }
            }
            
            // console.log("earned_discount_to_apply", earned_discount_to_apply, earned_shirt_has_shirt, earned_hat_has_hat, earned_yeti_has_yeti);
  
          }, 200)
  
        }).catch();
        
        if(document.querySelectorAll('.js-claim-incentives').length == 0){
          document.querySelector('.js-incentives').insertAdjacentHTML("afterend", `
            <div class="js-claim-incentives">
              <a class="js-claim-incentives--resilient" href="/cart/add/32995408380043?return_to=${window.location.pathname}?cart=open" class>Claim Your Free Resilient [HERE]</a>
              <a class="js-claim-incentives--shirt" href="/collections/gear" class>Claim Your Free Shirt [HERE]</a>
              <a class="js-claim-incentives--hat" href="/products/protekt-multicam-trucker" class>Claim Your Free Hat [HERE]</a>
              <a class="js-claim-incentives--yeti" href="/cart/add/${window.yeti_var_id}?return_to=${window.location.pathname}?cart=open" class>Claim Your Free Yeti [HERE]</a>
            </div>
          `);
        }
  
        let incentives_message = document.querySelector('.js-incentives-mesage')
        let incentives_bar_filled = document.querySelector('.js-incentives--bar--filled')
        let incentives_message_set = false;
        let earned_incentives = [];
  
        if(current_cart_subtotal >= incentives_max){
          incentives_bar_filled.style.width = "100%";
          incentives_message.innerHTML = `Awesome <strong>FREE SHIPPING</strong> headed your way!`;
        } else {
          setTimeout(() => {
            let met_thresholds = document.querySelectorAll('.js-threshold-met');
            let next_threshold = document.querySelector('.js-incentives--threshold');
            incentives_bar_filled.style.minWidth = "0px";
            if(met_thresholds.length > 0){
              let current_threshold = met_thresholds[met_thresholds.length - 1];
              next_threshold = met_thresholds[met_thresholds.length - 1].nextElementSibling;
              incentives_bar_filled.style.minWidth = `${current_threshold.getAttribute("data-range")}%`;
            }
  
            incentives_bar_filled.style.width = `${(current_cart_subtotal / next_threshold.getAttribute("data-threshold")) * next_threshold.getAttribute("data-range")}%`;
            
          }, 200)
        }
  
        // reset for evaluation
        document.documentElement.setAttribute("data-resilient-threshold-met", false);
        document.documentElement.setAttribute("data-shirt-threshold-met", false);
        document.documentElement.setAttribute("data-hat-threshold-met", false);
        document.documentElement.setAttribute("data-yeti-threshold-met", false);
  
        let incentives_thresholds = document.querySelectorAll('.js-incentives--threshold');
        incentives_thresholds[0].classList.add('js-tease');
        for(let i = 0; i < incentives_thresholds.length; i++){
  
          let incentives_message_html = ""; 
  
          let threshold_amount = parseInt(incentives_thresholds[i].getAttribute("data-threshold"));
          let threshold_label = incentives_thresholds[i].getAttribute("data-label");
          let threshold_var_id = incentives_thresholds[i].getAttribute("data-var-id");
  
          if(current_cart_subtotal >= threshold_amount){
            incentives_thresholds[i].classList.add('js-threshold-met');
            incentives_thresholds[i].classList.add('js-reveal');
  
            if(threshold_label == "FREE Resilient"){
              document.documentElement.setAttribute("data-resilient-threshold-met", true);
            } else if(threshold_label == "A FREE T-SHIRT"){
              document.documentElement.setAttribute("data-shirt-threshold-met", true);
            } else if(threshold_label == "A FREE HAT"){
              document.documentElement.setAttribute("data-hat-threshold-met", true);
            } else if(threshold_label == "A FREE YETI"){
              document.documentElement.setAttribute("data-yeti-threshold-met", true);
            }
            
            // tesase the next
            if(i+1 < incentives_thresholds.length){
              incentives_thresholds[i+1].classList.add('js-tease');
            }
            if(threshold_var_id != "none"){
              earned_incentives.push(threshold_var_id);
            }
          } else {
            incentives_thresholds[i].classList.remove('js-threshold-met');
            incentives_thresholds[i].classList.remove('js-reveal');
            // un-tesase the next
            if(i+1 < incentives_thresholds.length){
              incentives_thresholds[i+1].classList.remove('js-tease');
            }
          }
  
          if(!incentives_message_set){
            if(current_cart_subtotal < threshold_amount){
              incentives_message_html = `Only $${((threshold_amount - current_cart_subtotal)/100).toFixed(2)} away from <strong>${threshold_label}</strong>`;
  
              incentives_message.innerHTML = incentives_message_html;
              incentives_message_set = true;
            }
          }
  
          if(i == incentives_thresholds.length - 1){
            // last loop
  
            let items_to_auto_add = [];
  
            for(let ii = 0; ii < earned_incentives.length; ii++){
  
              if(ii == earned_incentives.length -1){
                // last loop
                if(items_to_auto_add.length > 0){
  
                  cart_add_item(items_to_auto_add[0], 1, () => {
                    if(items_to_auto_add.length > 1){
                      cart_add_item(items_to_auto_add[1], 1, () => {
                        window.location = window.location.origin + window.location.pathname + "?cart=open&qa=PT-07";
                      });
                    } else {
                      window.location = window.location.origin + window.location.pathname + "?cart=open&qa=PT-07";
                    }
                  });
  
                }
  
                // LAST LAST LOOP
  
  
              }
            }
          }
  
        }
  
      }; // update_incentives_module()
  
      observeSelector('[data-cart-subtotal]', cart_subtotal => {
        console.log("data-cart-subtotal located");
  
        let applied_discount_total = 0;
  
        waitUntil(() => {
          return document.querySelectorAll('cart-drawer.show-close-cursor').length > 0;
        }).then(() => {
          update_incentives_module(cart_subtotal.getAttribute("data-cart-subtotal"), applied_discount_total);
        }).catch();
  
        // update incentives bar
        observeSelector('.cart-drawer__line-items line-item', () => {
          update_incentives_module(cart_subtotal.getAttribute("data-cart-subtotal"), applied_discount_total);
        });
  
        // init incentives bar
        waitUntil(() => {
          return document.querySelectorAll('.cart-drawer__line-items line-item').length > 0;
        }).then(() => {
          update_incentives_module(cart_subtotal.getAttribute("data-cart-subtotal"), applied_discount_total);
          console.log("init update_incentives_module() +");
          setTimeout(() => {
            update_incentives_module(document.querySelector('[data-cart-subtotal]').getAttribute("data-cart-subtotal"), applied_discount_total);
            console.log("init update_incentives_module() ++");
          }, 500)
        }).catch();
  
        /*
        const innerText_observer = new MutationObserver(function(mutationsList) {
          for (let mutation of mutationsList) {
            if (mutation.type === 'childList' && mutation.target === cart_subtotal) {
  
              const new_InnerText = cart_subtotal.innerText;
              let cart_subtotal_price = parseFloat(new_InnerText.replace("$", "")).toFixed(2);
              update_incentives_module(cart_subtotal_price * 100, applied_discount_total);
  
            }
          }
        });
  
        const observerConfig = { childList: true, subtree: true };
        innerText_observer.observe(cart_subtotal, observerConfig);
        */
  
      });
  
    });

  };

}).catch();

//
// iteration of [PT-60]
//

waitForElement('body').then(doc => {

  doc.insertAdjacentHTML("afterbegin", `
  <style>
    .pt-variant-radio-wrapper[data-option-value="60 Pack"]{
      display: flex !important;
    }

    .pt-variant-radio-wrapper[data-option-value="180 Pack"]{
      display: none !important;
    }
    .variant-picker__option:last-of-type .variant-picker__option-values {
        display: flex;
        .block-swatch {
            flex: 1 1 0;
            text-align: center!important;
            span {
                width: 100%;
            }
        }
        .block-swatch.amount-10-pack {
            order: 1;
        }
        .block-swatch.amount-30-pack {
            order: 2;
        }
        .block-swatch.amount-60-pack {
            order: 3;
            display: flex;
        }
        .block-swatch.amount-90-pack {
            order: 4;
        }
        .block-swatch.amount-180-pack {
            order: 5;
            display: none;
        }
    }
    .rc-button-group__options {
        flex-direction: column;
    }
    .rc-radio {
        width: 100%!important;
        flex: none!important;
    }
    .rc-radio.subscription-radio {
        border-radius: 0 0 10px 10px !important;
        order: 2;
        position: relative;
    }

    .rc-radio.onetime-radio {
        border-radius: 10px 10px 0 0 !important;
        order: 1;
    }

    .rc-radio.subscription-radio .discount-label{
        font-size: 0;
    }

    .rc-radio.subscription-radio .discount-label:before{
        font-size: 1.1rem;
        content: "Subscribe and Save 15%"
    }

  </style>
  `)

  waitForElement('recharge-subscription-widget').then(rc_widget => {

    const extract_number = (str) => {
      const n = parseFloat(str.replace(/[^\d.-]+/g, '')); // keep digits, dot, minus
      return Number.isFinite(n) ? n : null;
    }

    waitUntil(() => {

      return !!(
        rc_widget.shadowRoot &&
        rc_widget.shadowRoot.querySelector('.rc-purchase-option.rc-selection__onetime') &&
        rc_widget.shadowRoot.querySelector('.rc-purchase-option.rc-purchase-option__subscription')
      );

    }).then(() => {

      let selected_option = document.querySelector('[name="option2"][id*="pack"]:checked');

      let update_values = (selected_option) => {

        let selected_label = document.querySelector(`label[for="${selected_option.id}"]`);
        let sticks_count = extract_number(selected_label.querySelector('.option--details').innerText);
        let savings = extract_number(selected_label.querySelector('.option--savings').innerText);

        let subs_price = rc_widget.shadowRoot.querySelector('.rc-purchase-option.rc-purchase-option__subscription .rc-purchase-option__prices');
        let otp_price = rc_widget.shadowRoot.querySelector('.rc-purchase-option.rc-selection__onetime .rc-purchase-option__prices');

        let sub_full_price = extract_number(subs_price.querySelector('.rc-price').innerText);
        let otp_full_price = extract_number(otp_price.querySelector('.rc-price').innerText);

        let calculated_full_price_sub = savings > 0 ? `$${parseFloat((otp_full_price + savings) * .85).toFixed(2)}` : `$${otp_full_price.toFixed(2)}`;

        if(rc_widget.shadowRoot.querySelectorAll('.js-price--sub').length == 0){
          subs_price.insertAdjacentHTML("beforebegin", `
            <div class="js-price--sub" style="position: absolute; right: 5rem; text-decoration: line-through;">${calculated_full_price_sub}</div>
          `);
        } else {
          rc_widget.shadowRoot.querySelector('.js-price--sub').innerText = `${calculated_full_price_sub}`;
        }

        let calculated_full_price_otp = savings > 0 ? `$${parseFloat(otp_full_price + savings).toFixed(2)}` : "";

        if(rc_widget.shadowRoot.querySelectorAll('.js-price--otp').length == 0){
          otp_price.insertAdjacentHTML("beforebegin", `
            <div class="js-price--otp" style="position: absolute; right: 5rem; text-decoration: line-through;">${calculated_full_price_otp}</div>
          `);
        } else {
          rc_widget.shadowRoot.querySelector('.js-price--otp').innerText = `${calculated_full_price_otp}`;
        }

        // "10 sticks / 30 days" → "1 stick every 3 days"
        // "60 sticks / 30 days" → "2 sticks per day"
        // Works for any positive integers.
        const stick_cadence = (sticks, days) => {
          if (!Number.isFinite(sticks) || !Number.isFinite(days) || sticks <= 0 || days <= 0) return "";

          const gcd = (a, b) => (b ? gcd(b, a % b) : Math.abs(a));
          const g = gcd(sticks, days);
          const a = sticks / g; // simplified sticks
          const b = days / g;   // simplified days

          const plural = (n, w) => n === 1 ? w : w + "s";

          // If it reduces to "… per 1 day", use the per-day phrasing.
          if (b === 1) {
            return `${a} ${plural(a, "stick")} per day`;
          }

          // If it reduces to "1 stick every N days", use the every-N-days phrasing.
          if (a === 1) {
            return `1 stick every ${b} ${plural(b, "day")}`;
          }

          // Otherwise, "A sticks every B days"
          return `${a} ${plural(a, "stick")} every ${b} ${plural(b, "day")}`;
        }

        console.log("testubg...", stick_cadence(sticks_count, 30))

        let option_0 = rc_widget.shadowRoot.querySelector('rc-selling-plans').shadowRoot.querySelector('.rc-plans-dropdown__select').options[0];
        let option_1 = rc_widget.shadowRoot.querySelector('rc-selling-plans').shadowRoot.querySelector('.rc-plans-dropdown__select').options[1];
        let option_2 = rc_widget.shadowRoot.querySelector('rc-selling-plans').shadowRoot.querySelector('.rc-plans-dropdown__select').options[2];

        option_0.text = `${option_0.text.split("(")[0]} (${stick_cadence(sticks_count, 30)})`;
        option_1.text = `${option_1.text.split("(")[0]} (${stick_cadence(sticks_count, 60)})`;
        option_2.text = `${option_2.text.split("(")[0]} (${stick_cadence(sticks_count, 90)})`;

      }

      // init
      update_values(selected_option);

      observeSelector('[name="option2"][id*="pack"]', option => {
        option.addEventListener("change", (e) => {

          setTimeout(() => {

            selected_option = document.querySelector('[name="option2"][id*="pack"]:checked');
            update_values(selected_option);

          }, 20)

        });
      });

      waitForElement('input.quantity-input[name="quantity"]').then(qty => {
        waitForElement('.js-purchase-options .js-otp').then(js_otp => {
          waitForElement('.js-purchase-options .js-subs').then(js_subs => {
          }).catch();
        }).catch();
      }).catch();
    }).catch();

  }).catch();

}).catch();

// END [PT-60]

(() => {

const thresholds = [
  {
    label: "2 FREE BOXES",
    amount: 10000,
  },
  {
    label: "3 FREE BOXES",
    amount: 15000,
  },
  {
    label: "5 FREE BOXES",
    amount: 25000,
  }
];

waitUntil(() => {
  return typeof window.cart_data != "undefined";
}).then(() => {

  observeSelector('free-shipping-bar', fs_bar => {

    fs_bar.setAttribute("total-price", window.cart_data.items_subtotal_price);
    fs_bar.setAttribute("threshold", thresholds[2].amount);
    fs_bar.setAttribute("reached-message", `🎉 You get free shipping and ${thresholds[2].label}!`);
    let progress_bar_html = `
      <style>
        progress-bar{
          position: relative;
          overflow: visible !important;
        }
        progress-bar .js-threshold{
          position: absolute;
          font-size: 11px;
          white-space: nowrap;
          bottom: -.35em;
          left: calc(${(thresholds[0].amount / thresholds[2].amount) * 100}%);
        }

        progress-bar .js-threshold span{
          position: absolute;
          top:0;
          left: -50%;
          transform: translateX(-50%);
        }

        progress-bar .js-threshold[data-index="1"]{
          left: calc(${(thresholds[1].amount / thresholds[2].amount) * 100}%);
        }
        progress-bar .js-threshold[data-index="2"]{
          left: calc(${(thresholds[2].amount / thresholds[2].amount) * 100}%);
        }

        progress-bar .js-threshold[data-index="2"] span{
          left: auto;
          right: 0;
          transform: none;
        }

        progress-bar .js-threshold:before{
          content: "";
          position: absolute;
          height: 1em;
          border-left: 1px solid;
          top: -1em;
          left: 50%;
        }
        @media(max-width: 700px){
          free-shipping-bar{
            margin-bottom: 1.5rem;
          }
        }
        
      </style>
      <span></span>
      <progress-bar class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="${thresholds[2].amount}" aria-valuenow="${window.cart_data.items_subtotal_price}">
        <div class="js-threshold" data-index="0"><span>${thresholds[0].label}</span></div>
        <div class="js-threshold" data-index="1"><span>${thresholds[1].label}</span></div>
        <div class="js-threshold" data-index="2"><span>${thresholds[2].label}</span></div>
      </progress-bar>
    `;

    if(window.cart_data.items_subtotal_price < 4950){

      fs_bar.setAttribute("unreached-message", `Spend <span class="bold text-accent">$${((4950 - window.cart_data.items_subtotal_price) / 100).toFixed(2)}</span> more and get free shipping!`);
      fs_bar.innerHTML = progress_bar_html;

    } else if(window.cart_data.items_subtotal_price < thresholds[0].amount){

      fs_bar.setAttribute("unreached-message", `You get free shipping.<br>Spend <span class="bold text-accent">$${((thresholds[0].amount - window.cart_data.items_subtotal_price) / 100).toFixed(2)}</span> more and get ${thresholds[0].label}!`);
      fs_bar.innerHTML = progress_bar_html;

    } else if(window.cart_data.items_subtotal_price < thresholds[1].amount){
      
      fs_bar.setAttribute("unreached-message", `You get free shipping and ${thresholds[0].label}.<br>Spend <span class="bold text-accent">$${((thresholds[1].amount - window.cart_data.items_subtotal_price) / 100).toFixed(2)}</span> more and get ${thresholds[1].label}!`);
      fs_bar.innerHTML = progress_bar_html;

    } else if(window.cart_data.items_subtotal_price < thresholds[2].amount){
      
      fs_bar.setAttribute("unreached-message", `You get free shipping and ${thresholds[1].label}.<br>Spend <span class="bold text-accent">$${((thresholds[2].amount - window.cart_data.items_subtotal_price) / 100).toFixed(2)}</span> more for ${thresholds[2].label}!`);
      fs_bar.innerHTML = progress_bar_html;

    }

    waitUntil(() => {
      return document.querySelectorAll('line-item').length > 0 && document.querySelector('line-item').innerText != "";
    }).then(() => {

      let num_of_10pack = 0;
      let line_items = document.querySelectorAll('line-item');
      for(let i = 0; i < line_items.length; i++){
        if(line_items[i].innerText.toLowerCase().indexOf("/ 10 pack") > -1 &&
      line_items[i].innerText.toLowerCase().indexOf("delivered every") == -1){
          num_of_10pack += parseInt(line_items[i].getAttribute("data-qty"));
        }
      }

      let threshold_offer = 0;
      if(window.cart_data.items_subtotal_price >= thresholds[2].amount){
        threshold_offer = 5;
      } else if(window.cart_data.items_subtotal_price >= thresholds[1].amount){
        threshold_offer = 3;
      } else if(window.cart_data.items_subtotal_price >= thresholds[0].amount){
        threshold_offer = 2;
      }

      if(num_of_10pack < threshold_offer){
        fs_bar.insertAdjacentHTML("afterend", `
          <div style="margin-top: .5em; font-size: .85rem; color: #1aaae0;">
            You have claimed <strong>${num_of_10pack} of ${threshold_offer} FREE 10ct boxes!</strong><br>
            <a href="/collections/10ct-boxes"><strong><u>Click here</u></strong></a> to add 10ct boxes.
          </div>
        `);
      } else if(threshold_offer > 0 && num_of_10pack >= threshold_offer) {
        fs_bar.insertAdjacentHTML("afterend", `
          <div style="margin-top: .5em; font-size: .85rem; color: #1aaae0;">
            All (${threshold_offer}) <strong>FREE 10ct boxes</strong> have been claimed.
          </div>
        `);
      }

    }).catch();
      
  })

}).catch();
})();